var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiDownloadicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6205",
    "data-name": "Group 6205",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.009,
    height: 16.009,
    viewBox: "0 0 16.009 16.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6204",
    "data-name": "Group 6204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47481",
    "data-name": "Path 47481",
    d: "M41.662,19a.74.74,0,0,0-.74.74v8.442l-2.83-2.83A.74.74,0,1,0,37.046,26.4l4.093,4.092a.74.74,0,0,0,1.047,0L46.279,26.4a.74.74,0,0,0-1.046-1.047L42.4,28.182V19.74a.74.74,0,0,0-.74-.74Z",
    transform: "translate(-33.658 -19)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47482",
    "data-name": "Path 47482",
    d: "M19.74,74.005a.74.74,0,0,0-.74.74v2.438a3.05,3.05,0,0,0,3.046,3.046h9.916a3.05,3.05,0,0,0,3.046-3.046V74.745a.74.74,0,0,0-1.48,0v2.438a1.568,1.568,0,0,1-1.567,1.567H22.046a1.568,1.568,0,0,1-1.567-1.567V74.745a.74.74,0,0,0-.74-.74Z",
    transform: "translate(-19 -64.221)",
    fill: "#4165f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDownloadicon);
export default __webpack_public_path__ + "static/media/api-downloadicon.1598e736bee657dc5bd77d7e3dfd9968.svg";
export { ForwardRef as ReactComponent };